/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';

import Axios from '@/lib/axios-instance';

type Props = {
    skip: number;
    limit: number;
};

export const getProactiveChats = async (limit: number, skip: number) => {
    try {
        const response = await Axios.post(`/pro_active_chats/list?skip=${skip}&limit=${limit}`, { url: "" });
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(
                `${error.response.data?.meta?.message || 'An error occurred'}`,
            );
        }
        throw new Error(error.message || 'Network Error');
    }
};

export const useGetProactiveChats = ({ limit, skip }: Props) => {
    const questions = useQuery({
        queryKey: ['get_proactive_chats', limit, skip],
        queryFn: () => getProactiveChats(limit, skip),
    });

    return questions;
};
